export const useHandleNetworkError = () => {
  // const {
  //   setIsOpenModalSystemError,
  //   setSystemErrorRequestType,
  //   setIsOpenModalApiRateLimit,
  //   setIsOpenModalSessionExpired,
  // } = useContext(AppContext)

  return (error) => {
    console.log('Error custom handling: ', error)
    // if (/status code 429/i.test(error)) {
    //   setIsOpenModalApiRateLimit(true)
    // } else if (/status code 401/i.test(error)) {
    //   setIsOpenModalSessionExpired(true)
    // } else {
    //   setIsOpenModalSystemError(true)
    //   setSystemErrorRequestType('QUERY')
    // }
  }
}

export const useHandleNetworkErrorMutation = () => {
  // const {
  //   setIsOpenModalSystemError,
  //   setSystemErrorRequestType,
  //   setIsOpenModalApiRateLimit,
  //   setIsOpenModalSessionExpired,
  // } = useContext(AppContext)

  return (error) => {
    console.log('Error custom handling mutation: ', error)
    // if (/status code 429/i.test(error)) {
    //   setIsOpenModalApiRateLimit(true)
    // } else if (/status code 401/i.test(error)) {
    //   setIsOpenModalSessionExpired(true)
    // } else {
    //   setIsOpenModalSystemError(true)
    //   setSystemErrorRequestType('MUTATION')
    // }
  }
}
